import { render, staticRenderFns } from "./timeNav.vue?vue&type=template&id=54061646&scoped=true&"
import script from "./timeNav.vue?vue&type=script&lang=js&"
export * from "./timeNav.vue?vue&type=script&lang=js&"
import style0 from "./timeNav.vue?vue&type=style&index=0&id=54061646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54061646",
  null
  
)

export default component.exports